var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overview clearfix"},[_c('div',{staticClass:"right-col"},[_c('overview-right-account-info',{on:{"send-indexdata":_vm.sendIndexDataHandle}})],1),_c('div',{staticClass:"left-col"},[_c('data-statistics-general',{attrs:{"data-statistics":_vm.accountInfo}}),_c('line-chart-and-symbol-chart'),_c('order-list')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }